import SourceFlowImage from "@sourceflow-uk/sourceflowimage";
import { Container, Row, Col } from 'reactstrap';
import styles from './styles.module.scss';
import Link from "next/link";
import Video from "@/components/Shared/Video";

export const ImageWithTextWithOverlay = ({
  className,
  image,
  title,
  heading,
  content,
  video_embed_url,
  buttonLink,
  buttonTitle,
  buttonNewTab,
  reversed,
}) => {

  return (
    <section className={`${styles.root} ${className}`}>
      <Container className="py-4 py-md-5">
        <Row className={`align-items-center ${reversed ? "flex-row-reverse" : ""}`}>
          <Col md={5} className={`left-column mb-5 mb-md-0 ${reversed ? "ps-md-5" : "pe-md-5"}`}>
            <figure className="m-0">
              {video_embed_url ? (
                <Video video_embed_url={video_embed_url} className="card-img rounded-4 overflow-hidden" />
              ) : (
                <SourceFlowImage
                  src={image?.url ? image?.url : "/site-assets/placeholders/img-placeholder.jpg"}
                  size={"800x600"}
                  alt={image?.alt}
                  className="card-img rounded-4"
                />
              )}
            </figure>
          </Col>
          <Col md={7} className={`right-column ${reversed ? "pe-md-5" : "ps-md-5"}`}>
            {title && (
              <h2 className={`${heading} fw-bold mb-4`}>
                  {title}
              </h2>
            )}
            {content &&
                <div className="mb-4" dangerouslySetInnerHTML={{ __html: content }} />
            }
            {buttonLink && buttonTitle &&
              <div>
                <Link href={buttonLink}>
                  <a className="primaryBtn no-arrow" target={buttonNewTab ? '_blank' : '_self'}>
                    {buttonTitle}
                  </a>
                </Link>
              </div>
            }
          </Col>
        </Row>
      </Container>
    </section>
  )
}

export default ImageWithTextWithOverlay;
